import React, { useState } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { loginRequest } from '../../authConfig';
import { PageLayout } from './components/PageLayout';
import { callMsGraph } from '../../graph';

import Button from 'lqa-ui/lib/Components/Button';

import { removeItem, setItem } from '../../helpers/storage';
import { IUser } from '../../interfaces/user/user';
import { AccessType } from '../../enums/AccessType';
import { IFileUploadRestrictionDto } from '../../interfaces/fileUpload/fileUploadRestrictionDto';
import './Login.scss';

import { useHistory } from 'react-router';
import { useMutationWithAuth } from '../../hooks/useMutationWithAuth';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import LoadingApp from 'lqa-ui/lib/Components/LoadingApp';

/**
 * Renders information about the signed-in user 
 * or a button to retrieve data about the user
 */
const ProfileContent = () => {
    const history = useHistory();
    const { instance, accounts } = useMsal();
    const [{ }, bootstrapRequest] = useMutationWithAuth(() => ({
        url: `${Env.API_URL}/bootstrap/fileUploadRestrictions`,
        options: {
            method: 'GET',
        },
    }));

    const rememberAuth = (user: IUser, token: string) => {
        removeItem('user');
        setItem('user', JSON.stringify({
            user,
            token,
        }));
    };

    const rememberFileUploadRestrictions = (restrictions: IFileUploadRestrictionDto) => {
        removeItem('fileUploadRestrictions');
        setItem('fileUploadRestrictions', JSON.stringify(restrictions));
    };
    RequestProfileData();
    function RequestProfileData() {
        // Silently acquires an access token which is then attached to a request for MS Graph data
        instance.acquireTokenSilent({
            ...loginRequest,
            account: accounts[0],
        }).then((response) => {
            callMsGraph(response.accessToken).then(async result => {
                    rememberAuth(result.user, result.accessToken);
                    rememberFileUploadRestrictions((await bootstrapRequest()).body);
                    localStorage.setItem('LoginUserData', JSON.stringify(result));
                    // Check that current URL contains no particular address
                    if (history.location.pathname === '/') {
                        if (AccessType.LQAAdmin === result.user.accessType || AccessType.LQABasic === result.user.accessType) {
                            history.push('/admin/');
                        } else if (
                            AccessType.brandClientUser === result.user.accessType ||
                            AccessType.masterClientUser === result.user.accessType ||
                            AccessType.clientUser === result.user.accessType
                        ) {
                            history.push('/brand/dashboard/');
                        } else {
                            history.push('/hotel/dashboard/');
                        }
                    } else if (
                        history.location.pathname === '/logout' || 
                        history.location.pathname === '/admin/logout'
                    ) {
                        history.push('/');
                    }
                    location.href='/';
            });
        });
    }

    return (
        <>
                {/* <Button title="secondary" onClick={RequestProfileData}>Gaurav Request Profile Information</Button> */}
        </>
    );
};

/**
 * If a user is authenticated the ProfileContent component above is rendered. Otherwise a message indicating a user is not authenticated is rendered.
 */
const MainContent = () => {    
    return (
        <div className="App">
            <AuthenticatedTemplate>
            <h5 className="card-title">Already In</h5>
                <ProfileContent />
            </AuthenticatedTemplate>

            <UnauthenticatedTemplate>
                {/* <h5 className="card-title">Redirecting to Microsoft....</h5> */}
                {/* <LoadingContent layout="flex"/> */}
                <LoadingApp/>
            </UnauthenticatedTemplate>
        </div>
    );
};

export default function App() {
    return (
        <PageLayout>
            <MainContent />
        </PageLayout>
    );
}
